module.exports = __webpack_public_path__ + "static/media/bars.31db4369.svg";